import { getDefaultConversation } from '@strata/react-chat';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';
import { type Location, useLocation } from 'react-router';

import { type MappedConversation, setUserSupportConversation } from 'services/userSupportHelpers';
import { useAppDispatch, useAppSelector } from 'store';
import { updateCurrentConversation } from 'store/userSupport/userSupportSlice';

export const useRedirectedConversation = (conversations?: MappedConversation[]) => {
    const location = useLocation() as Location<{ conversationId?: string }>;
    const dispatch = useAppDispatch();
    const { userSupportRestFetch } = useFlags<{ userSupportRestFetch?: boolean }>();
    const selectedConversationId = useAppSelector((state) => state.userSupport.currentConversation);
    const currentReferral = useAppSelector((state) => state.userSupport.currentReferral);

    useEffect(() => {
        const { defaultConversation } = conversations
            ? getDefaultConversation(conversations, true)
            : {};

        const { conversationId } = location.state ?? {};

        const redirectedConversation = conversationId ?? defaultConversation?.conversationId;

        if (!selectedConversationId && redirectedConversation) {
            dispatch(updateCurrentConversation({ conversationId: redirectedConversation }));
        }
    }, [conversations, dispatch, location, selectedConversationId]);

    // Will unset the subscribed conversation on unmount
    useEffect(
        () => () => {
            // With REST fetch on there is no socket subscription to clear.
            if (!userSupportRestFetch) {
                dispatch(setUserSupportConversation(null));
            }
            dispatch(updateCurrentConversation());
        },
        [dispatch, currentReferral, userSupportRestFetch],
    );
};
